import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from '../Button'
import { Input as StyledInput } from '../Input'
import { Loader } from '../Loader'

import {
  useCheckoutDiscountCode,
  useConfigState,
  useGlobalLabels,
} from '@sentecacommerce-theme/lib'
import { FormError } from '../FormError'
import { IconClose } from '../Icons'
import { TextField } from '@sentecacommerce-theme/base'

export const PromoCode = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [value, setValue] = useState('')
  const [error, setError] = useState('')
  const config = useConfigState()
  const { promoCodeLabels } = useGlobalLabels()

  const onAddCallback = () => {
    setValue('')
    setIsLoading(false)
  }

  const onAddError = (code: any) => {
    setError(
      promoCodeLabels?.errorsMap[code.status] ||
        promoCodeLabels?.promoCodeDefaultErrorMessage
    )
    setIsLoading(false)
  }

  const { handleDiscountCodeAdd: addCode } = useCheckoutDiscountCode(
    onAddCallback,
    onAddError
  )

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setError('')
    setValue(e.target.value)
  }

  const clear = () => {
    setError('')
    setValue('')
  }

  const onSubmit = async (e: React.MouseEvent<any>) => {
    e.preventDefault()

    setIsLoading(true)

    addCode({
      code: value,
    })
  }

  const getButtonContent = () => {
    if (isLoading) {
      return (
        <Loader
          width="2.2rem"
          height="2.2rem"
          stroke={config.palette.silverTree}
        />
      )
    }

    if (error) {
      return (
        <IconClose
          width="1.4rem"
          height="1.4rem"
          fill={config.palette.danger}
        />
      )
    }

    return promoCodeLabels?.promoCodeSubmitLabel
  }

  return (
    <Form>
      <Title htmlFor="promoCode">{promoCodeLabels?.promoCodeBoxTitle}</Title>
      <Flex>
        <Input
          onChange={onChange}
          id="promoCode"
          value={value}
          required
          placeholder={promoCodeLabels?.promoCodeInputPlaceholder}
        />
        <Button
          onClick={Boolean(error) ? clear : onSubmit}
          variant="green"
          bordered
          disabled={isLoading}
        >
          {getButtonContent()}
        </Button>
      </Flex>
      <div className="mt-2">
        <FormError text={error} />
      </div>
    </Form>
  )
}

export type PromoCodeLabels = {
  promoCodeBoxTitle: TextField
  promoCodeDefaultErrorMessage: TextField
  promoCodeSubmitLabel: TextField
  promoCodeInputPlaceholder: TextField
  errorsMap: {
    MaxApplicationReached: TextField
    NotValid: TextField
    NotActive: TextField
    DoesNotMatchCart: TextField
    ApplicationStoppedByPreviousDiscount: TextField
  }
}

const Form = styled.div`
  max-width: 100%;
`

const Input = styled<any>(StyledInput).attrs({
  className: 'm-0',
})`
  & + button {
    display: none !important;
  }

  &:valid {
    padding-right: 6rem;

    & + button {
      display: flex !important;
    }
  }
`

const Title = styled.label`
  display: block;
`

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-top: 0.8rem;

  & button {
    padding: 0 !important;
    min-width: 5.4rem !important;
    width: 5.4rem !important;
    height: 100% !important;
    align-items: center;
    justify-content: center;
    border: 0 !important;
    font-size: 1.4rem;

    position: absolute;
    right: 1rem;
    top: 0.1rem;

    &:hover {
      opacity: 0.8 !important;
    }

    & svg,
    path {
      opacity: 1 !important;
    }
  }
`
